import { colors, Icon } from '@zet/design-system'
import { i18n } from '@zet/localization'

export const leadSummary = [
  {
    icon: (
      <Icon type="AssignedOutlined" color={colors.success[100]} size={20} />
    ),
    title: i18n.t('leadSummary.fulfilled'),
    type: 'saleCompleted',
    keys: ['fullfilled', 'pfulfilled'],
    eventName: 'fulfillied_icon',
  },
  {
    icon: (
      <Icon type="AssignedOutlined" color={colors.warning[100]} size={20} />
    ),
    title: i18n.t('leadSummary.pending'),
    type: 'saleIncomplete',
    keys: ['actnreqrd', 'leadadded'],
    eventName: 'pending_icon',
  },
  {
    icon: (
      <Icon type="CircleCloseOutlined" color={colors.error[50]} size={20} />
    ),
    title: i18n.t('leadSummary.rejected'),
    type: 'rejected',
    keys: ['rejected'],
    eventName: 'rejected_icon',
  },
  {
    icon: <Icon type="CalenderOutlined" color={colors.error[50]} size={20} />,
    title: i18n.t('leadSummary.expired'),
    type: 'expired',
    keys: ['expired'],
    eventName: 'expired_icon',
  },
]

export const leadAddedFilter = {
  LEAD_ADDED: 'leadadded',
  LEAD_IN_PROGRESS: 'actnreqrd',
  PARTIALLY_FULFILLED: 'pfulfilled',
  FULFILLED: 'fullfilled',
  REJECTED: 'rejected',
  EXPIRED: 'expired',
}

export const isUpperCase = (str: string) => str === str.toUpperCase()
export const VKYCVideoLink = 'https://wee.bnking.in/c/MGJiMDlm'
export const VKYCVideoId = 'PGZmy8-QAK4'
export const VKYCVideoThumbail =
  'https://onecode-asset.s3.ap-south-1.amazonaws.com/Video+Thumbnail/Common_VKYC_Thumbnail.jpg'
